import { STRING_FILTER_OPERATION } from '../filter/operation.js';

export const DROPDOWN_STRING_OPTIONS = [
    [
        STRING_FILTER_OPERATION.containsStrict.id,
        STRING_FILTER_OPERATION.containsLoose.id,
        STRING_FILTER_OPERATION.doesNotContain.id,
    ],
    [STRING_FILTER_OPERATION.equals.id, STRING_FILTER_OPERATION.doesNotEqual.id],
    [STRING_FILTER_OPERATION.beginsWith.id, STRING_FILTER_OPERATION.endsWith.id],
] as const;
